// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  padding: 0;
  border: 0;
}
ion-item-divider#search-divider #filter-btn {
  --padding-end: 24px;
}
ion-item-divider #position-btn {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  justify-content: flex-end;
}

#headerSupport ion-toolbar ion-buttons[slot=start] {
  margin-left: 10px;
  margin-right: -24px;
}

.code-input {
  border-radius: 100px;
  background: var(--input-box-filled-active, #FFF);
  height: 63px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.code-input ion-icon {
  color: var(--ion-color-primary);
  width: 27%;
}

#stepOne .confirm {
  color: var(--text-Subttulos, #0D253A);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
#stepOne .message {
  color: var(--text-BODY, #2C4051);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
#stepOne .code {
  color: var(--text-Info, #788089);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  padding-left: 6px;
  margin-bottom: 4px;
}
#stepOne .code-input {
  height: 63px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: #FFF;
}
#stepOne .no-code {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
#stepOne .no-code span {
  color: var(--ion-color-primary);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#stepOne .item-code {
  border: 1px solid var(--ion-color-primary);
  border-radius: 10px;
}
#stepOne .send-code {
  color: var(--ion-color-primary);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 7px;
  padding-left: 6px;
}
#stepOne .lock-resend {
  color: #96BFF3 !important;
  pointer-events: none;
}
#stepOne .no-code {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 7px;
  padding-left: 6px;
}
#stepOne .no-code .new-code {
  color: var(--ion-color-primary);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#stepOne .error-code {
  color: var(--UI-Error, #D50000);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 7px;
  padding-left: 6px;
  margin-bottom: 0px;
}

.img-product {
  width: 70px;
  border-radius: 10px !important;
  overflow: hidden;
}

#subtitle-2 {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
}
#subtitle-2 #product-stock-title,
#subtitle-2 #product-edit,
#subtitle-2 #product-stock-add {
  width: 50%;
  color: var(--ion-text-color);
}
#subtitle-2 #product-stock-title {
  margin-left: 24px;
  font-size: 17px;
  font-weight: 500;
}
#subtitle-2 .store-item {
  font-size: 14px;
}
#subtitle-2 .store-item.item-title {
  font-weight: 700;
  color: var(--ion-color-dark);
}
#subtitle-2 .store-item.item-price {
  font-weight: 700;
  color: var(--ion-color-primary);
}
#subtitle-2 #product-stock-add {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
}
#subtitle-2 #product-stock-add ion-button {
  --padding-end: 24px;
  text-transform: capitalize;
}
#subtitle-2 #product-stock-add ion-button ion-icon {
  margin-right: 3px;
  width: 32px !important;
  height: 32px !important;
}

.prod-title {
  font-weight: 600;
}

.item-prod {
  --background: #ffffff;
}

.cont-item {
  padding: 10px 0px;
}
.cont-item span {
  border: 1px solid gray;
  padding: 3px 6px;
  border-radius: 5px;
  margin-right: 10px;
}

.status-task {
  float: right;
}

.status-pending {
  width: 13px;
  height: 13px;
  color: var(--ion-color-danger) !important;
  border-radius: 50%;
  margin-left: 7px;
}

.status-success {
  width: 13px;
  height: 13px;
  color: var(--ion-color-success) !important;
  border-radius: 50%;
  margin-left: 7px;
}

#tasks-right-pane {
  display: none;
}

#tasks-left-pane {
  width: 100%;
}

@media (min-width: 960px) {
  #tasks-right-pane {
    display: block;
  }
  .split-pane-container {
    height: 100vh;
  }
}
.main-title div {
  padding-left: 51px;
  margin-bottom: 0px;
  position: relative;
}
.main-title div .add-icon {
  height: 40px;
  position: absolute;
  right: 0px;
  width: 40px;
  cursor: pointer;
}
.main-title div .back-icon {
  height: 18px;
  border-radius: 50%;
  padding: 8px;
  width: 18px;
  cursor: pointer;
  color: #ffffff;
  position: absolute;
  left: 0px;
  background: var(--ion-color-primary);
}

.pwa-left-pane {
  margin-bottom: 20px;
  padding: 0px 40px 0px 80px;
}

.pwa-right-pane {
  padding: 0px 80px 0px 40px;
}

ion-item-divider {
  border-bottom: none;
}

#mainModules {
  margin-top: 24px;
  background: transparent;
  padding-left: 3px;
  padding-right: 3px;
}
#mainModules ion-item {
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  margin-bottom: 16px;
  color: #505B69;
  cursor: pointer;
}
#mainModules ion-item .arrow-icon {
  width: 32px;
  height: 32px;
}
#mainModules ion-item .icon-item {
  width: 40px;
  height: 40px;
  color: var(--ion-item-primary);
}
#mainModules ion-item ion-label {
  padding-left: 10px;
}
#mainModules ion-item ion-label h2 {
  color: var(--ion-color-primary);
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
}
#mainModules ion-item ion-label p {
  color: #A1A1A1;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

#AccountOptions {
  margin-top: 0px;
  padding-top: 0px !important;
  background: transparent;
  padding-left: 3px;
  padding-right: 3px;
}
#AccountOptions ion-item {
  border: 2px solid #ede9e9;
  min-height: 56px;
  margin-bottom: 24px;
  border-radius: 16px;
  height: 56px;
  --padding-start: 16px;
  --padding-end: 16px;
  --background: #fff;
  background: #fff;
}
#AccountOptions ion-item .arrow-icon {
  width: 24px;
  height: 24px;
  position: relative;
  bottom: 5px;
}
#AccountOptions ion-item .icon-item {
  width: 24px;
  height: 24px;
  margin: 0px 8px 0px 0px;
  position: relative;
  bottom: 4px;
}
#AccountOptions ion-item .icon-VENTASCLICK {
  color: #3889F2;
}
#AccountOptions ion-item .icon-BOXX {
  color: #3889F2;
}
#AccountOptions ion-item ion-label {
  padding-left: 10px;
  margin: 0px !important;
}
#AccountOptions ion-item ion-label h2 {
  color: var(--text-Ttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px;
}

.action-icon {
  cursor: pointer;
}

.item-checked ion-label {
  color: var(--ion-color-secondary) !important;
}
.item-checked h2 {
  color: var(--ion-color-secondary) !important;
}

ion-item {
  --highlight-color-focused: none;
}

.item-pass {
  background: #FFF;
  margin-bottom: 20px;
  border: 1px solid var(--ion-color-primary);
  border-radius: 10px;
}
.item-pass ion-input {
  --highlight-color-focused: none;
}
.item-pass ion-icon {
  position: absolute;
  right: 0px;
  z-index: 9;
  cursor: pointer;
}
.item-pass ion-input {
  font-size: 16px;
  --ion-font-size: 15px;
  padding-right: 32px !important;
}

.round-input {
  border-radius: 38px !important;
}

.detail-title {
  display: flex;
  align-items: center;
  margin-top: 34px;
  margin-bottom: 24px;
  line-height: 1;
  font-size: 34px;
  font-weight: 700;
  position: relative;
}
.detail-title .step-items {
  border-radius: 8px;
  background: var(--ion-color-primary);
  color: #FFF;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  width: 36px;
  height: 32px;
  position: absolute;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail-title ion-icon {
  height: 22px;
  border-radius: 50%;
  padding: 8px;
  position: absolute;
  right: 0px;
  width: 22px;
  cursor: pointer;
  color: #ffffff;
  background: var(--ion-color-primary);
}
.detail-title .subtitle {
  padding-left: 51px;
  margin-bottom: 0px;
  position: relative;
}
.detail-title .back-icon {
  left: 0px;
}

.subtitle-mt {
  margin-top: 40px;
}

.account-item-selected {
  --background: rgba(22, 54, 96, 0.10);
}

.sign-out {
  color: var(--UI-Error, #D50000);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 10px;
}

#passwordSection {
  padding: 24px 16px;
}
#passwordSection .title {
  color: var(--text-Subttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 0px;
}
#passwordSection .subtitle {
  color: var(--text-Subttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#passwordSection .item-password {
  border-radius: 8px;
  border: 1px solid var(--success, #05B300);
  background: #FFF;
  height: 66px;
  margin-bottom: 16px;
}

.section-logo {
  text-align: center;
  min-height: 203px;
  margin-left: 3px;
  margin-right: 3px;
  margin-top: 16px;
  padding: 16px 16px 0px 16px;
}
.section-logo .container-image div {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  padding: 5px;
  background-size: cover;
  margin: 0 auto;
  border: 4px solid var(--icons, #0C2340);
  padding: 5px;
}
.section-logo .default-image {
  padding: 5px;
  width: 149px;
  height: 149px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  border: 4px solid var(--icons, #0C2340);
}
.section-logo .default-image img {
  width: 142px;
  height: 132px;
  border-radius: 50%;
  border: none;
}
.section-logo .business-name {
  color: var(--text-Subttulos, #0D253A);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 5px;
  margin-bottom: 2px;
}
.section-logo .company-name {
  color: var(--text-Info, #788089);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 0px;
}
.section-logo hr {
  background: #D8D8D8;
  width: 100%;
  height: 1px;
}

#deleteAccountSection .delete-title {
  color: var(--text-Subttulos, #0D253A);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
#deleteAccountSection .delete-detail {
  color: var(--text-BODY, #2C4051);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media (max-width: 600px) {
  #mainModules {
    margin-top: 24px;
    background: transparent;
    padding-left: 3px;
    padding-right: 3px;
  }
  #mainModules ion-item {
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    margin-bottom: 16px;
    color: #505B69;
    cursor: pointer;
    --padding-start: 16px;
    --padding-end: 16px;
  }
  #mainModules ion-item .arrow-icon {
    width: 32px;
    height: 32px;
    margin-left: 8px;
  }
  #mainModules ion-item .icon-item {
    width: 32px;
    height: 32px;
    margin-right: 5px;
  }
  #mainModules ion-item ion-label {
    padding-left: 10px;
  }
  #mainModules ion-item ion-label h2 {
    color: #2D4462;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }
  #mainModules ion-item ion-label p {
    color: #A1A1A1;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
  }
  #AccountOptions ion-item ion-label {
    padding-left: 10px;
    margin-bottom: 0px;
    bottom: 5px;
  }
}
ion-segment {
  background: white;
  box-shadow: inset 0px 0px 3px 1px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}
ion-segment ion-segment-button {
  --indicator-box-shadow: transparent!important;
  margin: 0;
  --color-checked: white !important;
  --indicator-color: transparent!important;
  height: 40px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  --border-radius: 16px;
}
ion-segment ion-segment-button.segment-button-checked {
  color: #ffffff;
  --indicator-color: var(--ion-color-primary) !important;
}
ion-segment ion-segment-button.segment-button-checked ion-label {
  color: #ffffff;
}
ion-segment ion-segment-button:not(.segment-button-checked) {
  color: var(--ion-color-primary) !important;
}
ion-segment ion-segment-button:not(.segment-button-checked) ion-label {
  color: #A1A1A1;
}
ion-segment ion-segment-button::before {
  border-left: none;
}

ion-segment {
  margin-bottom: 8px;
  border-radius: 16px;
}
ion-segment ion-segment-button {
  height: 32px !important;
}
ion-segment ion-segment-button ion-label {
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

@media (max-width: 600px) {
  ion-accordion-group {
    margin-top: 24px;
    border-radius: 8px;
    background: #f8f8f8 !important;
    padding: 0px;
    box-shadow: none;
  }
  ion-accordion-group ion-accordion ion-item {
    --padding-start: 0px;
    --padding-end: 0px;
    --background: #f8f8f8 !important;
  }
  ion-accordion-group ion-accordion ion-item ion-label {
    color: var(--text-Ttulos, #0D253A);
    font-feature-settings: "liga" off, "clig" off;
    font-family: "Poppins";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  ion-accordion-group ion-accordion ion-item *[slot=end] {
    color: red !important;
  }
  ion-accordion-group .accordion-expanded {
    border-radius: 16px;
    background: #ECECEC;
  }
  ion-accordion-group .accordion-expanded ion-item {
    --background: #ECECEC !important;
    --padding-start: 8px;
    --padding-end: 8px;
  }
  .support-image {
    width: 126px;
    height: 144px;
  }
  .support-title {
    color: var(--Ttulos, #0C2340);
    text-align: center;
    font-family: "Montserrat";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .support-detail {
    color: var(--Ttulos, #0C2340);
    text-align: center;
    font-family: "Montserrat";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .container-ticket {
    padding-top: 30%;
  }
  .sign-out {
    margin-top: 19px;
    margin-left: 4px;
  }
}
ion-list {
  padding: 24px;
  padding-top: 24px !important;
}
ion-list ion-item ion-label {
  position: relative;
  margin-top: 10px;
  bottom: 17px;
  font-weight: 500;
}
ion-list ion-item .label-chip {
  position: initial;
  margin-top: 0px;
  margin-bottom: 0px;
  bottom: 17px;
  color: #07192F !important;
  font-weight: 600;
}
ion-list ion-item .label-stacked {
  margin-bottom: 4px;
  font-size: 14px;
  position: relative;
  top: -1px;
}

.item-TELMEX ion-icon {
  color: #3C7CCF;
}
.item-TELMEX ion-label {
  color: #3C7CCF;
}

.item-ENDIGITAL ion-icon {
  color: #00B5C6;
}
.item-ENDIGITAL ion-label {
  color: #1F2C3C;
}

.item-VENTASCLICK ion-icon {
  color: #9d9d9c;
}
.item-VENTASCLICK ion-label {
  color: #34495e;
}

.icon-GETNET {
  color: #e51514 !important;
}

.detail-info {
  color: var(--text-Info, #788089);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.c-pad-24 {
  padding: 24px 16px !important;
}

.c-pad-custom {
  padding: 24px 16px 16px 16px !important;
}

#pass-instructions {
  position: relative;
  background: var(--boxx-app-background, white);
  padding: 0px;
}
#pass-instructions #strength-indicators {
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
}
#pass-instructions #strength-indicators div {
  height: 8px;
  width: 100%;
  background: var(--boxx-app-lightgray, #dedede);
  margin-left: 3px;
  margin-right: 3px;
}
#pass-instructions #strength-indicators div:first-child {
  margin-left: 0;
}
#pass-instructions #strength-indicators div:last-child {
  margin-right: 0;
}
#pass-instructions #strength-text {
  position: absolute;
  right: 24px;
  top: 30px;
  font-size: 14px;
  font-weight: 600;
}
#pass-instructions ul {
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 16px;
  padding: 0px;
  padding-bottom: 16px;
  line-height: 1;
  color: var(--ion-color-primary);
  font-size: 14px;
  font-weight: 600;
  list-style: none;
}
#pass-instructions ul li {
  display: flex;
  align-items: center;
  padding-top: 3px;
  padding-bottom: 3px;
  line-height: 1;
  color: gray;
}
#pass-instructions ul li ion-icon {
  color: var(--ion-color-medium);
  width: 14px;
  margin-right: 8px;
}
#pass-instructions ul li ion-icon.active {
  color: var(--ion-color-success);
}
#pass-instructions ul .success {
  color: #0ab302;
}
#pass-instructions.valid-password div#strength-one.weak {
  background: red;
}
#pass-instructions.valid-password div#strength-one.medium {
  background: var(--ion-color-danger);
}
#pass-instructions.valid-password div#strength-one.strong {
  background: var(--ion-color-success);
}
#pass-instructions.valid-password div#strength-two.medium {
  background: var(--ion-color-danger);
}
#pass-instructions.valid-password div#strength-two.strong {
  background: var(--ion-color-success);
}
#pass-instructions.valid-password div#strength-three.strong {
  background: var(--ion-color-success);
}
#pass-instructions.valid-password #strength-text.weak {
  color: red;
}
#pass-instructions.valid-password #strength-text.medium {
  color: var(--ion-color-danger);
}
#pass-instructions.valid-password #strength-text.strong {
  color: var(--ion-color-success);
}

#container-success {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60vh;
}
#container-success .container-demo-pass {
  border-radius: 100px;
  background: var(--Input-Box-Filled-Active, #FFF);
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.2) inset;
  padding: 14px 44px;
  width: 95%;
  margin-top: 16px;
  margin-bottom: 27px;
}
#container-success .img-success {
  width: 120px;
  height: 120px;
  margin-bottom: 16px;
}
#container-success .title {
  color: var(--text-Subttulos, #0D253A);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
#container-success .detail {
  color: var(--text-BODY, #2C4051);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

ion-footer {
  box-shadow: none !important;
  --box-shadow: none !important;
}
ion-footer ion-toolbar {
  --background: #f8f8f8;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/support/options-support/options-support.page.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;AACF;AAEI;EACE,mBAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AAFJ;;AAOA;EACE,iBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,gDAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAME;EACE,+BAAA;EACA,UAAA;AAJJ;;AASE;EACE,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANJ;AASE;EACE,gCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;AAWE;EACE,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AATJ;AAYE;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVJ;AAYI;EACE,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVN;AAcE;EACE,0CAAA;EACA,mBAAA;AAZJ;AAgBE;EACE,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,yBAAA;EACA,oBAAA;AAfJ;AAkBE;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAhBJ;AAkBI;EACE,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhBN;AAoBE;EACE,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAlBJ;;AA2BA;EACE,WAAA;EACA,8BAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AAxBF;AA0BE;;;EAGE,UAAA;EACA,4BAAA;AAxBJ;AA2BE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AAzBJ;AA4BE;EACE,eAAA;AA1BJ;AA4BI;EACE,gBAAA;EACA,4BAAA;AA1BN;AA6BI;EACE,gBAAA;EACA,+BAAA;AA3BN;AA+BE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA7BJ;AA+BI;EACE,mBAAA;EACA,0BAAA;AA7BN;AA+BM;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;AA7BR;;AAmCA;EACE,gBAAA;AAhCF;;AAmCA;EACE,qBAAA;AAhCF;;AAmCA;EACE,iBAAA;AAhCF;AAkCE;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAhCJ;;AAoCA;EACE,YAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AAjCF;;AAuCA;EACE,aAAA;AApCF;;AAuCA;EACE,WAAA;AApCF;;AAwCA;EASE;IACE,cAAA;EA7CF;EAqDA;IACE,aAAA;EAnDF;AACF;AAyDA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAvDF;AAyDE;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;AAvDJ;AA0DE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;AAxDJ;;AA6DA;EACE,mBAAA;EAGA,0BAAA;AA5DF;;AA+DA;EACE,0BAAA;AA5DF;;AA+DA;EACE,mBAAA;AA5DF;;AAgEA;EACE,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AA7DF;AA+DE;EACE,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA7DJ;AA+DI;EACE,WAAA;EACA,YAAA;AA7DN;AAgEI;EACE,WAAA;EACA,YAAA;EACA,8BAAA;AA9DN;AAiEI;EACE,kBAAA;AA/DN;AAiEM;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA/DR;AAkEM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAhER;;AAsEA;EACE,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAnEF;AAqEE;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAnEJ;AA4EI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AA1EN;AA8EI;EACE,WAAA;EACA,YAAA;EAEA,uBAAA;EACA,kBAAA;EACA,WAAA;AA7EN;AAiFI;EACE,cAAA;AA/EN;AAkFI;EACE,cAAA;AAhFN;AAmFI;EACE,kBAAA;EACA,sBAAA;AAjFN;AAmFM;EACE,kCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAjFR;;AAuFA;EACE,eAAA;AApFF;;AAwFE;EACE,4CAAA;AArFJ;AAwFE;EACE,4CAAA;AAtFJ;;AA0FA;EACE,+BAAA;AAvFF;;AA0FA;EAGE,gBAAA;EACA,mBAAA;EAEA,0CAAA;EACA,mBAAA;AA1FF;AA4FE;EACE,+BAAA;AA1FJ;AA6FE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AA3FJ;AAoHE;EACE,eAAA;EACA,qBAAA;EACA,8BAAA;AAlHJ;;AAsHA;EACE,8BAAA;AAnHF;;AAsHA;EACE,aAAA;EACA,mBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AApHF;AAsHE;EACE,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AApHJ;AAuHE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;AArHJ;AAwHE;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAtHJ;AAyHE;EACE,SAAA;AAvHJ;;AA2HA;EACE,gBAAA;AAxHF;;AA2HA;EACE,oCAAA;AAxHF;;AA2HA;EACE,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAxHF;;AA2HA;EACE,kBAAA;AAxHF;AA0HE;EACE,qCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAxHJ;AA2HE;EACE,qCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAzHJ;AA4HE;EACE,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA1HJ;;AA+HA;EAME,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AAjIF;AA6II;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,uCAAA;EACA,YAAA;AA3IN;AAgJE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,uCAAA;AA9IJ;AAgJI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AA9IN;AAkJE;EACE,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAhJJ;AAmJE;EACE,gCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAjJJ;AAoJE;EACE,mBAAA;EACA,WAAA;EACA,WAAA;AAlJJ;;AAwJE;EACE,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AArJJ;AAwJE;EACE,gCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtJJ;;AA0JA;EACE;IACE,gBAAA;IACA,uBAAA;IACA,iBAAA;IACA,kBAAA;EAvJF;EAyJE;IACE,kBAAA;IACA,gBAAA;IACA,+CAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,qBAAA;IACA,mBAAA;EAvJJ;EAyJI;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAvJN;EA0JI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAxJN;EA4JI;IACE,kBAAA;EA1JN;EA4JM;IACE,cAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EA1JR;EA6JM;IACE,cAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EA3JR;EAiKA;IACE,kBAAA;IACA,kBAAA;IACA,WAAA;EA/JF;AACF;AAkKA;EACE,iBAAA;EACA,oDAAA;EACA,kBAAA;AAhKF;AAoKE;EACE,6CAAA;EACA,SAAA;EAEA,iCAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAnKJ;AAoKI;EACE,cAAA;EACA,sDAAA;AAlKN;AAmKQ;EACE,cAAA;AAjKV;AAoKI;EACE,0CAAA;AAlKN;AAoKM;EACE,cAAA;AAlKR;AAuKE;EACE,iBAAA;AArKJ;;AAyKA;EACE,kBAAA;EACA,mBAAA;AAtKF;AAwKE;EACE,uBAAA;AAtKJ;AAwKI;EAEE,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvKN;;AAkOA;EACE;IACE,gBAAA;IACA,kBAAA;IACA,8BAAA;IACA,YAAA;IACA,gBAAA;EA/NF;EAkOI;IACE,oBAAA;IACA,kBAAA;IACA,gCAAA;EAhON;EAkOM;IACE,kCAAA;IACA,6CAAA;IACA,sBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EAhOR;EAwOI;IACE,qBAAA;EAtON;EA2OE;IACE,mBAAA;IACA,mBAAA;EAzOJ;EA2OI;IACE,gCAAA;IACA,oBAAA;IACA,kBAAA;EAzON;EA8OA;IACE,YAAA;IACA,aAAA;EA5OF;EA+OA;IACE,6BAAA;IACA,kBAAA;IACA,yBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EA7OF;EAgPA;IACE,6BAAA;IACA,kBAAA;IACA,yBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EA9OF;EAiPA;IACE,gBAAA;EA/OF;EAsPA;IACE,gBAAA;IACA,gBAAA;EApPF;AACF;AAwPA;EACE,aAAA;EACA,4BAAA;AAtPF;AA0PI;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EAEA,gBAAA;AAzPN;AA4PI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AA1PN;AA6PI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AA3PN;;AAkQE;EACE,cAAA;AA/PJ;AAkQE;EACE,cAAA;AAhQJ;;AAqQE;EACE,cAAA;AAlQJ;AAqQE;EACE,cAAA;AAnQJ;;AAwQE;EACE,cAAA;AArQJ;AAwQE;EACE,cAAA;AAtQJ;;AA0QA;EACE,yBAAA;AAvQF;;AA0QA;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvQF;;AA0QA;EACE,6BAAA;AAvQF;;AA0QA;EACE,uCAAA;AAvQF;;AA0QA;EACE,kBAAA;EACA,6CAAA;EACA,YAAA;AAvQF;AAyQE;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;AAvQJ;AAyQI;EACE,WAAA;EACA,WAAA;EACA,8CAAA;EACA,gBAAA;EACA,iBAAA;AAvQN;AAyQM;EACE,cAAA;AAvQR;AA0QM;EACE,eAAA;AAxQR;AA6QE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AA3QJ;AA8QE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA5QJ;AA8QI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AA5QN;AA8QM;EACE,8BAAA;EACA,WAAA;EACA,iBAAA;AA5QR;AA8QQ;EACE,+BAAA;AA5QV;AAiRI;EACE,cAAA;AA/QN;AAqRM;EACE,eAAA;AAnRR;AAsRM;EACE,mCAAA;AApRR;AAuRM;EACE,oCAAA;AArRR;AA0RM;EACE,mCAAA;AAxRR;AA2RM;EACE,oCAAA;AAzRR;AA8RM;EACE,oCAAA;AA5RR;AAiSM;EACE,UAAA;AA/RR;AAkSM;EACE,8BAAA;AAhSR;AAmSM;EACE,+BAAA;AAjSR;;AAuSA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AApSF;AAsSE;EACE,oBAAA;EACA,gDAAA;EACA,oDAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;AApSJ;AAuSE;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AArSN;AAwSE;EACE,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtSJ;AAySE;EACI,gCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvSN;;AA2SA;EACE,2BAAA;EACA,6BAAA;AAxSF;AA0SE;EACE,qBAAA;AAxSJ","sourcesContent":["ion-item-divider {\n  padding: 0;\n  border: 0;\n\n  &#search-divider {\n    #filter-btn {\n      --padding-end: 24px;\n    }\n  }\n\n  #position-btn {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    justify-content: flex-end;\n\n  }\n}\n\n#headerSupport ion-toolbar ion-buttons[slot=start] {\n  margin-left: 10px;\n  margin-right: -24px;\n}\n\n.code-input {\n  border-radius: 100px;\n  background: var(--input-box-filled-active, #FFF);\n  height: 63px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ion-icon {\n    color: var(--ion-color-primary);\n    width: 27%;\n  }\n}\n\n#stepOne {\n  .confirm {\n    color: var(--text-Subttulos, #0D253A);\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n\n  .message {\n    color: var(--text-BODY, #2C4051);\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n\n  .code {\n    color: var(--text-Info, #788089);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-align: left;\n    padding-left: 6px;\n    margin-bottom: 4px;\n  }\n\n  .code-input {\n    height: 63px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    background: #FFF;\n  }\n\n  .no-code {\n    color: var(--text-BODY, #2C4051);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    span {\n      color: var(--ion-color-primary);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n  .item-code{\n    border: 1px solid var(--ion-color-primary);\n    border-radius: 10px;\n  }\n\n\n  .send-code {\n    color: var(--ion-color-primary);\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: \"Poppins\";\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-top: 7px;\n    padding-left: 6px;\n  }\n\n  .lock-resend {\n    color: #96BFF3 !important;\n    pointer-events: none;\n  }\n\n  .no-code {\n    color: var(--text-BODY, #2C4051);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 7px;\n    padding-left: 6px;\n\n    .new-code {\n      color: var(--ion-color-primary);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n  .error-code {\n    color: var(--UI-Error, #D50000);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 7px;\n    padding-left: 6px;\n    margin-bottom: 0px;\n  }\n\n}\n\nion-item-divider {\n  //background: #ffffff;\n}\n\n.img-product {\n  width: 70px;\n  border-radius: 10px !important;\n  overflow: hidden;\n}\n\n#subtitle-2 {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  #product-stock-title,\n  #product-edit,\n  #product-stock-add {\n    width: 50%;\n    color: var(--ion-text-color);\n  }\n\n  #product-stock-title {\n    margin-left: 24px;\n    font-size: 17px;\n    font-weight: 500;\n  }\n\n  .store-item {\n    font-size: 14px;\n\n    &.item-title {\n      font-weight: 700;\n      color: var(--ion-color-dark);\n    }\n\n    &.item-price {\n      font-weight: 700;\n      color: var(--ion-color-primary);\n    }\n  }\n\n  #product-stock-add {\n    font-size: 14px;\n    font-weight: 500;\n    text-align: right;\n\n    ion-button {\n      --padding-end: 24px;\n      text-transform: capitalize;\n\n      ion-icon {\n        margin-right: 3px;\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n  }\n}\n\n.prod-title {\n  font-weight: 600;\n}\n\n.item-prod {\n  --background: #ffffff;\n}\n\n.cont-item {\n  padding: 10px 0px;\n\n  span {\n    border: 1px solid gray;\n    padding: 3px 6px;\n    border-radius: 5px;\n    margin-right: 10px;\n  }\n}\n\n.status-task {\n  float: right;\n}\n\n.status-pending {\n  width: 13px;\n  height: 13px;\n  color: var(--ion-color-danger) !important;\n  border-radius: 50%;\n  margin-left: 7px;\n}\n\n.status-success {\n  width: 13px;\n  height: 13px;\n  color: var(--ion-color-success) !important;\n  border-radius: 50%;\n  margin-left: 7px;\n}\n\n\n\n\n#tasks-right-pane {\n  display: none;\n}\n\n#tasks-left-pane {\n  width: 100%;\n}\n\n//PWA\n@media (min-width: 960px) {\n  ion-item {\n    //cursor: pointer;\n  }\n\n  // #tasks-left-pane {\n  //   width: 42%;\n  // }\n\n  #tasks-right-pane {\n    display: block;\n  }\n\n\n  ion-header {\n    //display: none;\n  }\n\n  .split-pane-container {\n    height: 100vh;\n  }\n\n}\n\n\n\n.main-title div {\n  padding-left: 51px;\n  margin-bottom: 0px;\n  position: relative;\n\n  .add-icon {\n    height: 40px;\n    position: absolute;\n    right: 0px;\n    width: 40px;\n    cursor: pointer;\n  }\n\n  .back-icon {\n    height: 18px;\n    border-radius: 50%;\n    padding: 8px;\n    width: 18px;\n    cursor: pointer;\n    color: #ffffff;\n    position: absolute;\n    left: 0px;\n    background: var(--ion-color-primary);\n  }\n}\n\n\n.pwa-left-pane {\n  margin-bottom: 20px;\n  // padding: 0px 80px;\n  // padding-bottom: 10px;\n  padding: 0px 40px 0px 80px;\n}\n\n.pwa-right-pane {\n  padding: 0px 80px 0px 40px;\n}\n\nion-item-divider {\n  border-bottom: none;\n}\n\n\n#mainModules {\n  margin-top: 24px;\n  background: transparent;\n  padding-left: 3px;\n  padding-right: 3px;\n\n  ion-item {\n    border-radius: 8px;\n    background: #FFF;\n    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n    margin-bottom: 16px;\n    color: #505B69;\n    cursor: pointer;\n\n    .arrow-icon {\n      width: 32px;\n      height: 32px;\n    }\n\n    .icon-item {\n      width: 40px;\n      height: 40px;\n      color: var(--ion-item-primary);\n    }\n\n    ion-label {\n      padding-left: 10px;\n\n      h2 {\n        color: var(--ion-color-primary);\n        font-size: 22px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 28px;\n      }\n\n      p {\n        color: #A1A1A1;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 21px;\n      }\n    }\n  }\n}\n\n#AccountOptions {\n  margin-top: 0px;\n  padding-top: 0px !important;\n  background: transparent;\n  padding-left: 3px;\n  padding-right: 3px;\n\n  ion-item {\n    border: 2px solid #ede9e9;\n    min-height: 56px;\n    margin-bottom: 24px;\n    border-radius: 16px;\n    height: 56px;\n    --padding-start: 16px;\n    --padding-end: 16px;\n    --background: #fff;\n    background: #fff;\n\n    // border-radius: 8px;\n    // background: #FFF;\n    // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n    // margin-bottom: 16px;\n    // color: #505B69;\n    // cursor: pointer;\n\n    .arrow-icon {\n      width: 24px;\n      height: 24px;\n      position: relative;\n      bottom: 5px;\n      //margin: 0px;\n    }\n\n    .icon-item {\n      width: 24px;\n      height: 24px;\n      //color: #3C7CCF;\n      margin: 0px 8px 0px 0px;\n      position: relative;\n      bottom: 4px;\n      \n    }\n\n    .icon-VENTASCLICK {\n      color: #3889F2;\n    }\n\n    .icon-BOXX {\n      color: #3889F2;\n    }\n\n    ion-label {\n      padding-left: 10px;\n      margin: 0px !important;\n\n      h2 {\n        color: var(--text-Ttulos, #0D253A);\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: 'Poppins';\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        margin: 0px;\n      }\n    }\n  }\n}\n\n.action-icon {\n  cursor: pointer;\n}\n\n.item-checked {\n  ion-label {\n    color: var(--ion-color-secondary) !important;\n  }\n\n  h2 {\n    color: var(--ion-color-secondary) !important;\n  }\n}\n\nion-item {\n  --highlight-color-focused: none;\n}\n\n.item-pass {\n  // border-radius: 8px;\n  // border: 1px solid var(--success, #05B300);\n  background: #FFF;\n  margin-bottom: 20px;\n\n  border: 1px solid var(--ion-color-primary);\n  border-radius: 10px;\n\n  ion-input {\n    --highlight-color-focused: none;\n  }\n\n  ion-icon {\n    position: absolute;\n    right: 0px;\n    z-index: 9;\n    cursor: pointer;\n  }\n\n  // ion-label {\n  //   color: var(--success, #05B300) !important;\n  //   font-size: 15px;\n  //   font-style: normal;\n  //   font-weight: 500;\n  //   line-height: normal;\n  //   letter-spacing: -0.005px;\n  // }\n\n  // .item-has-focus {\n  //   ion-label {\n  //     color: var(--success, #05B300) !important;\n  //     font-size: 15px;\n  //     font-style: normal;\n  //     font-weight: 500;\n  //     line-height: normal;\n  //     letter-spacing: -0.005px;\n  //   }\n\n  // }\n\n\n  ion-input {\n    font-size: 16px;\n    --ion-font-size: 15px;\n    padding-right: 32px !important;\n  }\n}\n\n.round-input {\n  border-radius: 38px !important;\n}\n\n.detail-title {\n  display: flex;\n  align-items: center;\n  //margin-top: 97px;\n  margin-top: 34px;\n  margin-bottom: 24px;\n  line-height: 1;\n  font-size: 34px;\n  font-weight: 700;\n  position: relative;\n\n  .step-items {\n    border-radius: 8px;\n    background: var(--ion-color-primary);\n    color: #FFF;\n    text-align: center;\n    font-family: Montserrat;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n    width: 36px;\n    height: 32px;\n    position: absolute;\n    right: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  ion-icon {\n    height: 22px;\n    border-radius: 50%;\n    padding: 8px;\n    position: absolute;\n    right: 0px;\n    width: 22px;\n    cursor: pointer;\n    color: #ffffff;\n    background: var(--ion-color-primary);\n  }\n\n  .subtitle {\n    padding-left: 51px;\n    margin-bottom: 0px;\n    position: relative;\n  }\n\n  .back-icon {\n    left: 0px;\n  }\n}\n\n.subtitle-mt {\n  margin-top: 40px;\n}\n\n.account-item-selected {\n  --background: rgba(22, 54, 96, 0.10);\n}\n\n.sign-out {\n  color: var(--UI-Error, #D50000);\n  font-feature-settings: 'liga' off, 'clig' off;\n  font-family: 'Poppins';\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 10px;\n}\n\n#passwordSection {\n  padding: 24px 16px;\n\n  .title {\n    color: var(--text-Subttulos, #0D253A);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-top: 0px;\n  }\n\n  .subtitle {\n    color: var(--text-Subttulos, #0D253A);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .item-password {\n    border-radius: 8px;\n    border: 1px solid var(--success, #05B300);\n    background: #FFF;\n    height: 66px;\n    margin-bottom: 16px;\n  }\n}\n\n\n.section-logo {\n  // border-radius: 8px;\n  // background: #FFF;\n  // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n  // padding-top: 16px;\n  // padding-bottom: 3px;\n  text-align: center;\n  min-height: 203px;\n  margin-left: 3px;\n  margin-right: 3px;\n  margin-top: 16px;\n  padding: 16px 16px 0px 16px;\n\n  .container-image {\n    // padding: 5px;\n    // width: 149px;\n    // height: 149px;\n    // border-radius: 50%;\n    // box-sizing: border-box;\n    // margin: 0 auto;\n    // border: 4px solid var(--icons, #0C2340);\n    // position: relative;\n\n    div {\n      width: 80px;\n      height: 80px;\n      border-radius: 50%;\n      padding: 5px;\n      background-size: cover;\n      margin: 0 auto;\n      border: 4px solid var(--icons, #0C2340);\n      padding: 5px;\n      // margin-top: 20px;\n    }\n  }\n\n  .default-image {\n    padding: 5px;\n    width: 149px;\n    height: 149px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    border: 4px solid var(--icons, #0C2340);\n\n    img {\n      width: 142px;\n      height: 132px;\n      border-radius: 50%;\n      border: none;\n    }\n  }\n\n  .business-name {\n    color: var(--text-Subttulos, #0D253A);\n    text-align: center;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: \"Poppins\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-top: 5px;\n    margin-bottom: 2px;\n  }\n\n  .company-name {\n    color: var(--text-Info, #788089);\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 0px;\n  }\n\n  hr{\n    background: #D8D8D8;\n    width: 100%;\n    height: 1px;\n  }\n}\n\n\n#deleteAccountSection {\n  .delete-title {\n    color: var(--text-Subttulos, #0D253A);\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n\n  .delete-detail {\n    color: var(--text-BODY, #2C4051);\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n@media (max-width: 600px) {\n  #mainModules {\n    margin-top: 24px;\n    background: transparent;\n    padding-left: 3px;\n    padding-right: 3px;\n\n    ion-item {\n      border-radius: 8px;\n      background: #FFF;\n      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n      margin-bottom: 16px;\n      color: #505B69;\n      cursor: pointer;\n      --padding-start: 16px;\n      --padding-end: 16px;\n\n      .arrow-icon {\n        width: 32px;\n        height: 32px;\n        margin-left: 8px;\n      }\n\n      .icon-item {\n        width: 32px;\n        height: 32px;\n        margin-right: 5px;\n        //color: #3C7CCF !important;\n      }\n\n      ion-label {\n        padding-left: 10px;\n\n        h2 {\n          color: #2D4462;\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 28px;\n        }\n\n        p {\n          color: #A1A1A1;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 21px;\n        }\n      }\n    }\n  }\n\n  #AccountOptions ion-item ion-label {\n    padding-left: 10px;\n    margin-bottom: 0px;\n    bottom: 5px;\n  }\n}\n\nion-segment{\n  background: white;\n  box-shadow: inset 0px 0px 3px 1px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  //padding: 2px;\n\n\n  ion-segment-button {\n    --indicator-box-shadow: transparent!important;\n    margin: 0;\n    //--background: white;\n    --color-checked: white !important;\n    --indicator-color: transparent!important;\n    height: 40px;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    --border-radius: 16px;\n    &.segment-button-checked {\n      color: #ffffff;\n      --indicator-color: var(--ion-color-primary) !important;\n        ion-label{\n          color: #ffffff;\n        }\n    }\n    &:not(.segment-button-checked) {\n      color: var(--ion-color-primary) !important;\n\n      ion-label{\n        color: #A1A1A1;\n      }\n    }\n  }\n\n  ion-segment-button::before{\n    border-left: none;\n  }\n}\n\nion-segment {\n  margin-bottom: 8px;\n  border-radius: 16px;\n\n  ion-segment-button {\n    height: 32px !important;\n\n    ion-label{\n      //color: #FFF;\n      text-align: center;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n  }\n}\n\n// ion-segment {\n//   background: white;\n//   box-shadow: inset 0px 0px 3px 1px #eaeef4;\n//   border-radius: 8px;\n//   padding: 2px;\n\n//   ion-segment-button {\n//     --indicator-box-shadow: transparent !important;\n//     margin: 0;\n//     --background: white;\n//     --color-checked: white !important;\n//     --indicator-color: transparent !important;\n//     height: 40px;\n//     font-style: normal;\n//     font-weight: 600;\n//     font-size: 12px;\n//     --border-radius: 16px;\n\n//     &.segment-button-checked {\n//       color: #ffffff; \n//       --indicator-color: var(--ion-color-primary) !important;\n\n//       ion-label {\n//         color: #ffffff;\n//         font-size: 12px;\n//         font-family: 'Poppins';\n//         font-style: normal;\n//         font-weight: 600;\n//         line-height: normal;\n//       }\n//     }\n\n//     &:not(.segment-button-checked) {\n//       color: var(--ion-color-primary) !important;\n\n//       ion-label {\n//         color: var(--text-Info, #788089);\n//         text-align: center;\n//         font-feature-settings: 'liga' off, 'clig' off;\n//         font-family: 'Poppins';\n//         font-size: 12px;\n//         font-style: normal;\n//         font-weight: 400;\n//         line-height: normal;\n//       }\n//     }\n//   }\n\n//   ion-segment-button::before {\n//     border-left: none;\n//   }\n// }\n\n\n@media (max-width: 600px) {\n  ion-accordion-group {\n    margin-top: 24px;\n    border-radius: 8px;\n    background: #f8f8f8 !important;\n    padding: 0px;\n    box-shadow: none;\n\n    ion-accordion {\n      ion-item {\n        --padding-start: 0px;\n        --padding-end: 0px;\n        --background: #f8f8f8 !important;\n\n        ion-label {\n          color: var(--text-Ttulos, #0D253A);\n          font-feature-settings: 'liga' off, 'clig' off;\n          font-family: 'Poppins';\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: normal;\n        }\n      }\n\n      // ion-item:hover {\n      //   --background: #ffffff !important;\n      // }\n\n      ion-item *[slot=end] {\n        color: red !important;\n      }\n\n    }\n\n    .accordion-expanded {\n      border-radius: 16px;\n      background: #ECECEC;\n\n      ion-item {\n        --background: #ECECEC !important;\n        --padding-start: 8px;\n        --padding-end: 8px;\n      }\n    }\n  }\n\n  .support-image {\n    width: 126px;\n    height: 144px;\n  }\n\n  .support-title {\n    color: var(--Ttulos, #0C2340);\n    text-align: center;\n    font-family: \"Montserrat\";\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n\n  .support-detail {\n    color: var(--Ttulos, #0C2340);\n    text-align: center;\n    font-family: \"Montserrat\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .container-ticket {\n    padding-top: 30%;\n  }\n\n  #AccountOptions {\n    //margin-top: 8px;\n  }\n\n  .sign-out {\n    margin-top: 19px;\n    margin-left: 4px;\n  }\n}\n\n\nion-list {\n  padding: 24px;\n  padding-top: 24px !important;\n\n  ion-item {\n\n    ion-label {\n      position: relative;\n      margin-top: 10px;\n      bottom: 17px;\n      //color: #07192F !important;\n      font-weight: 500;\n    }\n\n    .label-chip {\n      position: initial;\n      margin-top: 0px;\n      margin-bottom: 0px;\n      bottom: 17px;\n      color: #07192F !important;\n      font-weight: 600;\n    }\n\n    .label-stacked {\n      margin-bottom: 4px;\n      font-size: 14px;\n      position: relative;\n      top: -1px;\n    }\n\n  }\n}\n\n.item-TELMEX {\n  ion-icon {\n    color: #3C7CCF;\n  }\n\n  ion-label {\n    color: #3C7CCF;\n  }\n}\n\n.item-ENDIGITAL {\n  ion-icon {\n    color: #00B5C6;\n  }\n\n  ion-label {\n    color: #1F2C3C;\n  }\n}\n\n.item-VENTASCLICK {\n  ion-icon {\n    color: #9d9d9c;\n  }\n\n  ion-label {\n    color: #34495e;\n  }\n}\n\n.icon-GETNET {\n  color: #e51514 !important;\n}\n\n.detail-info {\n  color: var(--text-Info, #788089);\n  font-feature-settings: 'liga' off, 'clig' off;\n  font-family: 'Poppins';\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.c-pad-24 {\n  padding: 24px 16px !important;\n}\n\n.c-pad-custom{\n  padding: 24px 16px 16px 16px !important;\n}\n\n#pass-instructions {\n  position: relative;\n  background: var(--boxx-app-background, white);\n  padding: 0px;\n\n  #strength-indicators {\n    display: flex;\n    margin-left: 24px;\n    margin-right: 24px;\n\n    div {\n      height: 8px;\n      width: 100%;\n      background: var(--boxx-app-lightgray, #dedede);\n      margin-left: 3px;\n      margin-right: 3px;\n\n      &:first-child {\n        margin-left: 0;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n\n  #strength-text {\n    position: absolute;\n    right: 24px;\n    top: 30px;\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  ul {\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 16px;\n    padding: 0px;\n    padding-bottom: 16px;\n    line-height: 1;\n    color: var(--ion-color-primary); //this is a simple change to update the repo\n    font-size: 14px;\n    font-weight: 600;\n    list-style: none;\n\n    li {\n      display: flex;\n      align-items: center;\n      padding-top: 3px;\n      padding-bottom: 3px;\n      line-height: 1;\n      color: gray;\n\n      ion-icon {\n        color: var(--ion-color-medium);\n        width: 14px;\n        margin-right: 8px;\n\n        &.active {\n          color: var(--ion-color-success);\n        }\n      }\n    }\n\n    .success{\n      color: #0ab302;\n    }\n  }\n\n  &.valid-password {\n    div#strength-one {\n      &.weak {\n        background: red;\n      }\n\n      &.medium {\n        background: var(--ion-color-danger);\n      }\n\n      &.strong {\n        background: var(--ion-color-success);\n      }\n    }\n\n    div#strength-two {\n      &.medium {\n        background: var(--ion-color-danger);\n      }\n\n      &.strong {\n        background: var(--ion-color-success);\n      }\n    }\n\n    div#strength-three {\n      &.strong {\n        background: var(--ion-color-success);\n      }\n    }\n\n    #strength-text {\n      &.weak {\n        color: red;\n      }\n\n      &.medium {\n        color: var(--ion-color-danger);\n      }\n\n      &.strong {\n        color: var(--ion-color-success);\n      }\n    }\n  }\n}\n\n#container-success {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n\n  .container-demo-pass{\n    border-radius: 100px;\n    background: var(--Input-Box-Filled-Active, #FFF);\n    box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.20) inset;\n    padding: 14px 44px;\n    width: 95%;\n    margin-top: 16px;\n    margin-bottom: 27px;\n  }\n\n  .img-success {\n      width: 120px;\n      height: 120px;\n      margin-bottom: 16px;\n  }\n\n  .title {\n    color: var(--text-Subttulos, #0D253A);\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n\n  .detail{\n      color: var(--text-BODY, #2C4051);\n      text-align: center;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n  }\n}\n\nion-footer {\n  box-shadow: none !important;\n  --box-shadow: none !important;\n\n  ion-toolbar{\n    --background: #f8f8f8;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
